module.exports = __webpack_public_path__ + "img/multiplier_normal_2.06e7d4f3.png";